import { render, staticRenderFns } from "./TabelaResumoImportacoesBasesSiga.vue?vue&type=template&id=012c90e2&"
import script from "./TabelaResumoImportacoesBasesSiga.vue?vue&type=script&lang=js&"
export * from "./TabelaResumoImportacoesBasesSiga.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VProgressCircular,VSimpleTable})
